import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import strings from '../../strings';

export default class ShoppingCartModalBase extends Component {
    render() {
        return (
            <Modal
                dialogClassName={this.props.modalClassName}
                show={this.props.visible}
                animation={false}
                backdrop={this.props.backdrop}
                onHide={() => this.props.closeModal()}
            >
                <div className="shopping-cart">
                    <Modal.Header>
                        <Modal.Title>
                            <span className='title'>{this.props.modalTitle}</span>
                            <button
                                type="button"
                                className="close"
                                aria-label={strings.close}
                                onClick={() => this.props.closeModal()}
                            >
                                <span className="x-symbol">×</span>
                                <span className="sr-only">{strings.close}</span>
                            </button>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.props.children}</Modal.Body>
                </div>
            </Modal>
        );
    }
}



// WEBPACK FOOTER //
// ./app/components/Modals/ShoppingCartBase.jsx